import { z } from "zod/v4";

import { AudioDevicePreferences } from "@/enums/preferences";

export const baseCallLogTextSchema = z.object({
  id: z.number(),
  content: z.string(),
  provider: z.string().nullable(),
});

export const AudioDeviceResponseSchema = z.object({
  created_at: z.string(),
  id: z.number(),
  key: z.enum(AudioDevicePreferences),
  updated_at: z.string(),
  value: z.object({
    device_id: z.string(),
    label: z.string(),
  }),
});
